// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option___6CBa"};